import React from "react";
import TokenBox from "../../TokenBox";

const Screen13 = () => {
    return <TokenBox />;
};

export default Screen13;
